export default "__VITE_PUBLIC_ASSET__208a6331__"